/**
 * jockey__dafengche module
 * @module
 */

const Jockey = window.Jockey;

/** @type {Object} */
module.exports = {
	/**
	 * 获取原生数据
	 */
	getData: function () {
		var d = $.Deferred();
		Jockey.send('getData', function(data) {
			/**
			 * 所需数据项:{
				'token':'FCHE-8-6enneGGaRrvHjzn7uX2G1DmNohkK7',
				'reportId':'000055',
				'serverUrl': 'http://f2e.souche.com',          //   线上: 'https://f2e-assets.souche.com' ,测试 : 'https://f2e.souche.com' ,预发：’https'://f2e.souche.com/prepub‘，
				 'erpUrl':"http://erp.sqaproxy.souche.com"    ,   //线上：‘’，测试：“https://erp.sqaproxy.souche.com”，
				'APP_DATAREPORT_OVERVIEW':"1",
				'APP_DATAREPORT_SALE_MANAGER':"1",
				'APP_DATAREPORT_ASSESS_MANAGER':"1",
				'APP_DATAREPORT_MARKETING':"1",
				'APP_DATAREPORT_INVENTORY':"1",
				'APP_DATAREPORT_SALE_INDIVIDUAL':"1",
				'APP_DATAREPORT_ASSESS_INDIVIDUAL':"1",
				'APP_DATAREPORT_NEWS':"1",
				'ACCREDIT_CAR_BASIC': "1" ,    //新增新车代销权限
				'setting':'test'    //新增环境配置    测试环境 'test',预发环境: 'prepub', 线上环境 : 'online',
				'version': '4.6.1'
				}
			 */
			if (data) {
				d.resolve(data);
			}
		});
		return d;
	},
	/**
	 * @deprecated
	 * 打开新链接
	 */
	loadH5: function (url, title, carId, hasScore) {
		Jockey.send('loadH5', {
			title: title || '',
			url: url,
			carId: carId,
			// 左上角是否有战报入口
			hasScore: '1'
		});
	},
	/**
	 * 打开客户详情页
	 */
	loadUserInfo: function (userId) {
		Jockey.send('loadUserInfo', {
			userId: userId
		});
	},
	/**
	 * 打开看车记录
	 */
	loadCarRecord: function (carId) {
		Jockey.send('loadCarRecord', {
			carId: carId
		});
	},
	/**
	 * 打开感兴趣的客户
	 */
	loadMatchedUser: function (carId) {
		Jockey.send('loadMatchedUser', {
			carId: carId
		});
	},
	/**
	 * 打开评估师车辆页面
	 */
	toAssessCarDetail: function (assessid) {
		Jockey.send('loadMatchedUser', {
			assessid: assessid
		});
	},
	/**
	 * 加载中隐藏
	 */
	h5LoadingHide: function () {
		Jockey.send('h5LoadingHide');
	},
	/** 打开加载中 */
	openLoading: function () {
		Jockey.send('openLoading');
	},
	/**
	 * 打开订单详情
	 */
	toOrderDetail: function (orderId) {
		Jockey.send('toOrderDetail', {
			orderId: orderId
		});
	},
	/**
	 * 打开原生数据详情
	 */
	goToDetailData: function (type, store, start, end) {
		Jockey.send('goToDetailData', {
			// store:"000055",
			store: store,
            // start:"2015-10-11",
            start: start,
            // end:"2015-12-10",
            end: end,
            // type的类型:
	        // seller --销售主管查看详细数据
	        // assess --评估主管查看详细数据
	        // sellerPersonal --销售查看详细数据
	        // assessPersonal --评估查看详细数据
	        // stock -- 查看库龄和价格交叉分析表
            type: type
		});
	},
	/**
	 * 选择时间段
	 */
	selectTime: function (startTime, endTime) {
		Jockey.send('selectTime', {
			// startTime:"2016-1-1",
			startTime: startTime,
	        endTime: endTime
		});
	},
	/**
	 * 打开客户列表
	 */
	openCustomList: function (data) {
		var _data = $.extend({
			store: "000055",
            seller: "15433333333",
            begin: "2015-11-1",
            end: "2015-12-3",
            type: "1",
            source:"site", //新增字段来源
            pageType: "1",//页面类型 1经理报表 2个人报表
		}, data);
		Jockey.send('openCustomList', _data);
	},
	/**
	 * 打开车辆列表
	 */
	openCarList: function (data) {
		var _data = $.extend({
			store: "000055",
	        seller: "15433333333",
	        begin: "2015-11-1",
	        end: "2015-12-3",
	        type: "1",

	        source:"site", //新增字段来源
	        pageType: "1" ,//页面类型 1经理报表 2个人报表
		}, data);
		Jockey.send('openCarList', _data);
	},
	/**
	 * 打开未匹配车辆列表
	 */
	openUnMatchedCar: function (store, series) {
		Jockey.send('openUnMatchedCar', {
			store: store,
			// series: ["", "series-1127", "series-1398", "series-1502", "series-1648"]
			series: series
		})
	},
	/**
	 * 打开库存车辆
	 */
	openSellingCar: function (store) {
		Jockey.send('openSellingCar', {
			store: store
		});
	},
	/**
	 * 估价参考打开同车系的车
	 */
	openSameBrandCar: function (carId, type) {
		Jockey.send('openSameBrandCar', {
			carId: carId,
			// type: "1"     //    零售市场:1 , 本店在售 :2 ,本店已售: 3
			type: type
		});
	},
	/**
	 * 打开看车记录
	 */
	loadCarRecord: function (carId) {
		Jockey.send('loadCarRecord', {
			carId: carId
		});
	},
	/**
	 * 打开匹配客户
	 */
	loadMatchedUser: function (carId) {
		Jockey.send('loadMatchedUser', {
			carId: carId
		});
	},
	/**
	 * 切换页面 tab
	 */
	changeTab: function (tab) {
		Jockey.send('changeTab', {
			tab: tab
		});
	},
	/**
	 * 打开原生车辆详情
	 */
	openAppCarDetail: function (carId) {
		Jockey.send('openAppCarDetail', {
			carId: carId
		});
	},
	/**
	 * @deprecated
	 * 
	 * 关闭顶部分享
	 */
	changeShareButtonVisible: function () {
		Jockey.send('changeShareButtonVisible', {
			hidden: '1'
		});
	},
	/**
	 * 触发分享
	 */
	openShare: function (data) {
		var _data = {
			text: data.title,
			content: data.desc,
			imgsrc: data.imgUrl,
			url: data.link
		};
		Jockey.send('openShare', _data);
	},
	/**
	 * ***********************************
	 * 以下 API 已弃用
	 * ***********************************
	 */
	/**
	 * @deprecated
	 * 使用 jockey__cheniu.setWebViewTitle(...) 代替
	 * 改变标题
	 */
	changeTitle: function (title) {
		Jockey.send('changeTitle', {
			title: title
		});
	},
	/**
	 * @deprecated
	 * 使用 jockey__cheniu.browsePic(...) 替代
	 * 打开图片大图
	 */
	loadCarPhoto: function (picIndex, picUrl) {
		Jockey.send('loadCarPhoto', {
			// picUrl 传一个图片的数组
			picUrl: picUrl,
			picIndex: picIndex
		});
	}
}



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/myjockey/src/jockey__dafengche.js
// module id = 286
// module chunks = 4